import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { ButtonComponent } from '../button/button.component';
import { UserDataService } from '../../../app/core/services/user-data/user-data.service';

@NgModule({
  imports: [
    NgxMaskDirective,
    NgxMaskPipe,
    ButtonComponent,
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  exports: [
    NgxMaskDirective,
    NgxMaskPipe,
    ButtonComponent,
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  providers: [UserDataService],
})
export class ImportsModule {}
